"use client";
import {
  __async
} from "../../chunk-MMUBH76A.js";
import { AuthMethod, getPublicKeyHex } from "@getpara/web-sdk";
import { useModalStore } from "../stores/index.js";
import { useInternalClient } from "../../provider/hooks/utils/useInternalClient.js";
const useSetLoginURLs = () => {
  const para = useInternalClient();
  const setWebAuthURLForLogin = useModalStore((state) => state.setWebAuthURLForLogin);
  const setPasswordURLForLogin = useModalStore((state) => state.setPasswordUrlForLogin);
  const setSupportedAuthMethods = useModalStore((state) => state.setSupportedAuthMethods);
  return (_0) => __async(void 0, [_0], function* ({
    supportedAuthMethods,
    authType,
    displayName,
    pfpUrl
  }) {
    setSupportedAuthMethods(supportedAuthMethods);
    const res = yield para.touchSession();
    const webAuthUrlForLogin = (supportedAuthMethods == null ? void 0 : supportedAuthMethods.has(AuthMethod.PASSKEY)) ? yield para.shortenLoginLink(
      yield para.getWebAuthURLForLogin({
        sessionId: res.data.sessionId,
        loginEncryptionPublicKey: getPublicKeyHex(para.loginEncryptionKeyPair),
        partnerId: res.data.partnerId,
        newDeviceSessionId: res.data.sessionLookupId,
        newDeviceEncryptionKey: getPublicKeyHex(para.loginEncryptionKeyPair),
        authType,
        displayName,
        pfpUrl
      })
    ) : void 0;
    const passwordAuthUrlForLogin = (supportedAuthMethods == null ? void 0 : supportedAuthMethods.has(AuthMethod.PASSWORD)) ? yield para.shortenLoginLink(
      yield para.getPasswordURLForLogin({
        sessionId: res.data.sessionId,
        loginEncryptionPublicKey: getPublicKeyHex(para.loginEncryptionKeyPair),
        partnerId: res.data.partnerId,
        authType,
        displayName,
        pfpUrl
      })
    ) : void 0;
    setWebAuthURLForLogin(webAuthUrlForLogin);
    setPasswordURLForLogin(passwordAuthUrlForLogin);
  });
};
export {
  useSetLoginURLs
};
